import { saveAs } from 'file-saver'
import { __isEnvDev } from '../config'
import 'whatwg-fetch'

export const savePdf = (url, name) => {
  window
    .fetch(url, {
      responseType: 'blob',
    })
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response)
      }
      return response.blob()
    })
    .then((blob) => saveAs(blob, name + '.pdf'))
    .catch((error) => {
      if (__isEnvDev()) {
        console.log('Save PDF request failed', error)
      }
    })
}

export const getPdfFileName = (url) => {
  const arr = RegExp('[\\w\\d\\.-]+.pdf', 'g').exec(url)
  if (arr && arr.length) {
    return arr[0]
  }
  return 'document-' + Date.now().toString()
}
